import {
  ConfigSchema,
  getBoolean,
  getString,
  getStringMap,
  InferConfigType,
  OmicronConfigResponseType,
  WithTypeCheck,
} from '@utils/omicron';

export const OmicronConfigSchema = {
  QR_REDIRECTS: {
    value: getStringMap(),
    description:
      'Набор ссылок для редиректа при переходе на rustore.ru/offers/qr',
    team: 'Growth',
  },
  WEB_AUTO_DOWNLOAD: {
    value: getBoolean(),
    description:
      'Флаг на автоскачивание apk при переходе на страницу инструкции ',
    team: 'Growth',
  },
  WEB_SHOW_MINIPICKS: {
    value: getBoolean(),
    description: 'Флаг на показ подборки приложений в блоке поиска',
    team: 'Growth',
  },
  WEB_SHOW_SEARCH: {
    value: getBoolean(),
    description: 'Флаг на показ поиска',
    team: 'Growth',
  },
  WEB_SHOW_BEELINE: {
    value: getBoolean(),
    description: 'Флаг на показ партнерской страницы Beeline',
    team: 'Growth',
  },
  WEB_SHOW_DVIJENIE_PERVIKH: {
    value: getBoolean(),
    description: 'Флаг на показ партнерской страницы "Движение первых"',
    team: 'Growth',
  },
  WEB_BEELINE_OFFER: {
    value: getString(),
    description: 'Текст оферты партнерской страницы Beeline',
    team: 'Growth',
  },
  WEB_DVIJENIE_PERVIH_OFFER: {
    value: getString(),
    description: 'Текст оферты партнерской страницы "Движение первых"',
    team: 'Growth',
  },
  WEB_SHOW_RUSTORE_OPEN: {
    value: getBoolean(),
    description: 'Флаг на показ формы "Предложить приложение" ',
    team: 'Growth',
  },
  WEB_SHOW_PROSTORE_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ списка статей в блоге',
    team: 'Growth',
  },
  WEB_SHOW_AURORA_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы ОС Аврора',
    team: 'Growth',
  },
  WEB_SHOW_REDESIGN: {
    value: getBoolean(),
    description: 'Флаг на показ варианта лендинга с редизайном',
    team: 'Growth',
  },
  WEB_SHOW_KIDS_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы родительского контроля',
    team: 'Growth',
  },
  WEB_SHOW_INSTRUCTION_REDESIGN: {
    value: getBoolean(),
    description: 'Флаг на показ страницы инструкции в новом виде (редизайн)',
    team: 'Growth',
  },
  WEB_SHOW_AUTOUPDATE_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы "Автообновления приложений RuStore" ',
    team: 'Growth',
  },
  WEB_SHOW_CAREER_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы карьеры',
    team: 'Growth',
  },
  WEB_SHOW_LOCALIZATION: {
    value: getBoolean(),
    description: 'Флаг на показ локализации главной страницы лединга витрины',
    team: 'Growth',
  },
} satisfies ConfigSchema;

export type OmicronConfigType = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronResponse = OmicronConfigResponseType<OmicronConfigType>;
